import React, {useState} from "react";
import {
  Card,
  IconButton,
  Typography,
} from "@material-tailwind/react";
import {
  CubeIcon,
  CurrencyDollarIcon,
  PencilSquareIcon,
  PlusIcon,
  TagIcon,
  TrashIcon
} from "@heroicons/react/24/outline";
import FormPresentation from "./FormPresentation";
import {INITIAL_VALUE_PRICE, PRODUCT_WEIGHT, setMoney} from "../../../utils/shared";
import {ModalComponent} from "../../../components/elements/Modal/ModalComponent";


export function Presentation({push, values, searchProduct, warehouse, errors, ...helpers}) {
  const [openModal, setOpenModal] = useState(false);
  const [showModal, setShowModal] = useState(false);
  const [indexToRemove, setIndexToRemove] = useState(0);
  const [itemPresentation, setItemPresentation] = useState({});


  const handleAddPresentation = () => {
    push({
      name: '',
      description: '',
      unit: '',
      conversion: 1,
      prices: INITIAL_VALUE_PRICE
    });
    helpers.form.setFieldError('presentations', 'Debe ingresar los datos');
    setItemPresentation({indexPre: values?.presentations?.length});
    setTimeout(()=>{
      setShowModal(true);
    }, 50)
  };

  const editAction = (itemP) => {
    setItemPresentation(itemP);
    setShowModal(true);
  };

  const handleRemovePresentation = (index) => {
    setIndexToRemove(index);
    setOpenModal(true);
  };

  const confirmRemovePresentation = () => {
    helpers.remove(indexToRemove);
    setOpenModal(false);
  };

  return (
    <Card className="h-full w-full rounded-none p-4" style={{flexBasis: '150px !important'}}>
      {/*MODAL QUE SE MOSTRARA PARA LLENAR UNA PRESENTACIÓN O EDITARLA */}
      <FormPresentation
        {...helpers}
        helpForm={helpers.form}
        values={values}
        push={push}
        show={showModal}
        handleOpen={setShowModal}
        item={itemPresentation}
      />

      {/*DETALLE DE TODAS LAS PRESENTACIONES */}
      <div className="w-full flex flex-row justify-between">
        <Typography
          variant="h4"
          color="black"
          className="mb-1"
        >
          Presentaciones del Producto
        </Typography>
        <IconButton className={`${helpers.isView ? "hidden": ""}`}>
          {/*<PlusIcon className="w-5 h-5 " onClick={() => push({})}></PlusIcon>*/}
          <PlusIcon className="w-5 h-5 " onClick={handleAddPresentation}></PlusIcon>
        </IconButton>
      </div>
      <div>
        <Typography
          variant="small"
          color="blue-gray"
          className="mb-3"
        >
          Se listan las diferentes presentaciones y sus precios
        </Typography>
      </div>
      <div className="grid gap-4 grid-cols-[repeat(auto-fit,_minmax(250px,_1fr))] py-2">
        {
          values?.presentations?.map((presentation, indexPre) => (
              <Card className="min-w-[250px] max-w-[300px] border rounded-none p-2" key={indexPre}>
                <div className="">

                  <div className="flex flex-row gap-2 opacity-80 justify-end ">
                    <span
                      className="absolute top-1 right-1 opacity-80 grid min-h-[24px] border-gray-400 min-w-[24px] place-items-center rounded-full border py-1 px-1 text-xs text-black">
                      {indexPre + 1}
                    </span>
                  </div>

                  <div className="flex flex-row gap-2 opacity-80  ">
                    <CubeIcon className="w-5 h-5 text-black"/>
                    <Typography className="" color="black">
                      <strong className="font-bold">Presentación: </strong> {presentation.name}
                    </Typography>
                  </div>

                  <div className="flex flex-row gap-2 opacity-80">
                    <TagIcon className="w-5 h-5 text-black"/>
                    <Typography className="" color="black">
                      <strong className="font-bold">Medida: </strong>{PRODUCT_WEIGHT.find((pw)=> pw.value ===presentation.unit )?.label}
                    </Typography>
                  </div>

                  <div className="flex flex-row gap-2 opacity-80">
                    <CurrencyDollarIcon className="w-5 h-5 text-black"/>
                    <Typography className="" color="black">
                      <strong className="font-bold">Precio: </strong>
                      {setMoney(presentation?.prices[0]?.amount ?? 0)}
                    </Typography>
                  </div>

                  <div className={`flex flex-row justify-end ${helpers.isView ? "hidden": ""}`}>
                    <div className="">
                      <IconButton
                        onClick={()=>{editAction({ indexPre: indexPre, ...presentation})}}
                        disabled={helpers.isView}
                        variant="text"
                        className="text-amber-600 rounded-b">
                        <PencilSquareIcon className="w-5 h-5"/>
                      </IconButton>
                    </div>
                    <div className="">
                      <IconButton
                        onClick={() => handleRemovePresentation(indexPre)}
                        variant="text"
                        disabled={helpers.isView}
                        className="text-red-400 rounded-b">
                        <TrashIcon className="w-5 h-5"/>
                      </IconButton>
                    </div>
                  </div>

                </div>
              </Card>
            )
          )
        }
      </div>

      <ModalComponent
        show={openModal}
        setShow={setOpenModal}
        title={'Eliminar presentación'}
        message={`¿Está seguro que desea eliminar esta presentación: ${indexToRemove + 1}?`}
        labelButtonCancel="Cancelar"
        labelButtonConfirm="Eliminar"
        onConfirm={confirmRemovePresentation}
      />

    </Card>
  );
}